import * as React from 'react';
import * as Styled from './styled.desktop';
import {
    Input,
    IconButton,
    withStyles,
    Tooltip,
    CircularProgress,
    Collapse
} from '@material-ui/core';
import {
    Add, Search, FlipToBack, FlipToFront, 
    KeyboardArrowUp, KeyboardArrowDown, Today, Loop
} from '@material-ui/icons';
import SortByAlphaIcon from '@material-ui/icons/SortByAlpha';
import { inject, observer } from 'mobx-react';
import { RootStore } from 'store/root.store';
import { Route } from 'react-router';
import TemplateFormContainer from './TimerContainer';
import TimerStore from 'store/Timer/timer.store';
import styled from 'common/styled-components';
import { Loading } from '../../containers/TimeEntries/styled';
import { parseCode } from 'util/utils';
import { Client, Matter, Features, TimeKeeperAssignment } from '../../api/types/types';
import AutoCompleteField from 'components/AutoCompleteField';
import { ApiConsumer } from 'common/ApiProvider';
import RootAPI from '../../api/interfaces/RootAPI';
import { FeaturesConsumer } from 'common/FeaturesProvider';
import TimerLink from './TimerLink';
import { TKConsumer } from 'common/TKProvider';
import { AutoSizer, List, ListRowProps } from 'react-virtualized';
import { withTranslation } from 'react-i18next';

interface Props {
    rootStore?: RootStore;
    timerStore?: TimerStore;
    match: {
        url: string;
    };
    // tslint:disable:no-any
    classes: any;
    t: any;
    // tslint:enable:no-any
}
interface GGProps extends ListRowProps {
    timerStore?: TimerStore;
}
interface State {
    expanded: boolean;
}
export const FabProgress = styled(CircularProgress)`
    position: absolute;
    top: -6;
    left: -6;
    z-index: 1;
`
const styles = () => ({
    button: {
        '&:hover': {
            backgroundColor: 'none'
        },
        backgroundColor: 'white',
        marginRight: 36,
        opacity: 0.9,
        width: 36,
        height: 36,
        padding: 0
    },
    defaultButton: {
        '&:hover': {
            backgroundColor: 'white',
            opacity: 0.9
        },
        backgroundColor: 'none',
        marginRight: 36,
        width: 36,
        height: 36,
        padding: 0
    }
});

class ListRow extends React.Component<GGProps> {
    render() {
        const { index, key, style, timerStore } = this.props;
        const {
            selectedTimer,
            loadingTimer,
            filteredTimers,
            startTimer,
            stopTimer,
            changeSelectedTimer,
            deleteTimer,
            addTimerNote,
            isActiveToday,
            rootStore
        } = timerStore!;
        const includeSubmitted = rootStore.appStore.features.EpochConfigTimeSegmentsSubmittedVisible;
        const timer = filteredTimers[index];

        return (
            <div
                key={key}
                style={style}
                onClick={() => changeSelectedTimer(timer.id)}
            >
                <TimerLink
                    key={timer.id!.toString()}
                    timer={timer}
                    selected={selectedTimer && selectedTimer.id === timer.id}
                    onDelete={deleteTimer(timer)}
                    onStart={startTimer(timer)}
                    onStop={stopTimer(timer.id!)}
                    loadingId={loadingTimer}
                    includeSubmitted={includeSubmitted}
                    disableDelete={timer.active}
                    onAddNote={addTimerNote(timer!)}
                    isActiveToday={isActiveToday(timer)}
                    style={style}
                />
            </div>
        );
    }
}

@inject((allStores: { rootStore: RootStore }) => {
    let rootStore = allStores.rootStore;
    return {
        rootStore: rootStore,
        timerStore: rootStore.timerStore
    };
})
@observer
class Timers extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            expanded: false
        }
    }
    componentDidMount() {
        this.props.timerStore!.setClientFilterValue();
        this.props.timerStore!.setMatterFilterValue();
        this.props.timerStore!.resetTodayTimerFlag();
        this.props.timerStore!.loadTimers();
    }
    componentWillUnmount() {
        this.props.timerStore!.onSearchChange('');
        this.props.timerStore!.setClientFilterValue();
        this.props.timerStore!.setMatterFilterValue();
    }
    handleExpansion = () => {
        this.setState({ expanded: !this.state.expanded });
    }
    render() {
        const { match, classes, timerStore, t } = this.props;
        const { expanded } = this.state;
        const {
            selectedTimer,
            onSearchChange,
            loadingTimer,
            // deleteTemplate,
            // newTemplate,
            newTimer,
            filteredTimers,
            searchText,
            openTimerPopOut,
            popOutOpen,
            closePopOut,
            mainWinLoading,
            sortByAlphaNumericToggle,
            toggleAlphaNumericHandler,
            clientFilter,
            setClientFilter,
            matterFilter,
            setMatterFilter,
            updateFilterTodayTimers,
            filterTodayTimersFlag,
            resetSortAndFilterTimers,
            applyingFilter,
            timerLoading,
            playAndStopLoading,
            activeTimerUpdateSteps
        } = timerStore!;
        const disableTimers = timerLoading || !!loadingTimer || !!playAndStopLoading || !!activeTimerUpdateSteps;
        const matterLabel = timerStore!.rootStore.appStore.features.EpochConfigMatterLabel;
        return (
            <Styled.Container disabled={disableTimers}>
                <div>
                    <Styled.Header>
                        <Styled.SearchContainer>
                            <Search
                                style={{ marginRight: '6px' }}
                            />
                            <Input
                                placeholder={t('header.field.search.placeholder')}
                                fullWidth={true}
                                style={{ maxWidth: '60%' }}
                                value={searchText}
                                onChange={e => onSearchChange(e.target.value)}
                            />
                        </Styled.SearchContainer>
                        <Styled.Title variant="h6">
                            {t('header.title')}
                        </Styled.Title>
                        <Styled.NewActions>
                            <TKConsumer>
                                { (tk: TimeKeeperAssignment) =>
                                    <>
                                        {tk.writable &&
                                            <>
                                                {popOutOpen ?
                                                    <Tooltip title={t('header.action.timers_window.hide')}>
                                                        <IconButton
                                                            onClick={closePopOut}
                                                            className={classes.button}
                                                        >
                                                            <FlipToFront/>
                                                        </IconButton>
                                                    </Tooltip> :
                                                    <Tooltip title={t('header.action.timers_window.show')}>
                                                        <IconButton
                                                            onClick={openTimerPopOut}
                                                            className={classes.defaultButton}
                                                        >
                                                            <FlipToBack/>
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                                <Tooltip title={t('header.action.add')}>
                                                    <IconButton
                                                        onClick={newTimer}
                                                        className={classes.defaultButton}
                                                    >
                                                        <Add/>
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        }
                                    </>
                                }
                            </TKConsumer>
                            {expanded ?
                                <Tooltip title={t('collapse', { ns: 'common' })}>
                                    <IconButton
                                        onClick={this.handleExpansion}
                                        className={classes.button}
                                    >
                                        <KeyboardArrowUp />
                                    </IconButton>
                                </Tooltip>
                            :
                                <Tooltip title={t('expand', { ns: 'common' })}>
                                    <IconButton
                                        onClick={this.handleExpansion}
                                        className={classes.defaultButton}
                                    >
                                        <KeyboardArrowDown />
                                    </IconButton>
                                </Tooltip>
                            }
                        </Styled.NewActions>
                    </Styled.Header>
                    <Collapse in={expanded}>
                        <ApiConsumer>
                            {(api: RootAPI) =>
                            <Styled.AdvancedHeader>
                                <Styled.AutoCompleteFilters>
                                    <AutoCompleteField
                                        label={t('header.filter.client')}
                                        fetch={(search: string) => api.Timer.getDistinctClientsFromTimers(search)}
                                        currentItem={clientFilter ? clientFilter : null}
                                        getItemText={(c: Client) => parseCode(c.number, c.name)}
                                        clearable={true}
                                        onClear={() => setClientFilter(null, (clientFilter === null) ? true : false)}
                                        onSelect={setClientFilter}
                                    />
                                </Styled.AutoCompleteFilters>
                                <Styled.AutoCompleteFilters>
                                    <AutoCompleteField
                                        label={t('header.filter.matter', { matterLabel })}
                                        fetch={(search: string) =>
                                            api.Timer.getDistinctMattersFromTimers(
                                                search,
                                                clientFilter ? clientFilter.id : 0
                                            )
                                        }
                                        currentItem={matterFilter ? matterFilter : null}
                                        getItemText={(m: Matter) => parseCode(m.number, m.name)}
                                        clearable={true}
                                        onClear={() => setMatterFilter(null, (matterFilter === null) ? true : false)}
                                        onSelect={setMatterFilter}
                                    />
                                </Styled.AutoCompleteFilters>
                                <Tooltip
                                    title={sortByAlphaNumericToggle ?
                                        t('header.filter.sort_by.descending')
                                    :
                                        t('header.filter.sort_by.ascending')}
                                >
                                    <Styled.FilterButton
                                        className={sortByAlphaNumericToggle ? classes.button : classes.defaultButton}
                                        onClick={toggleAlphaNumericHandler}
                                    >
                                        <SortByAlphaIcon />
                                    </Styled.FilterButton>
                                </Tooltip>
                                <Tooltip
                                    title={filterTodayTimersFlag ?
                                        t('header.filter.show.all')
                                    :
                                        t('header.filter.show.today_only')}
                                >

                                    <Styled.FilterButton
                                        className={filterTodayTimersFlag ? classes.button : classes.defaultButton}
                                        onClick={updateFilterTodayTimers}
                                    >
                                        <Today />
                                    </Styled.FilterButton>
                                </Tooltip>
                                <Tooltip title={t('header.filter.reset')}>
                                    <Styled.FilterButton
                                        className={classes.defaultButton}
                                        onClick={resetSortAndFilterTimers}
                                    >
                                        <Loop />
                                    </Styled.FilterButton>
                                </Tooltip>
                            </Styled.AdvancedHeader>}
                        </ApiConsumer>
                    </Collapse>
                </div>

                <Styled.ContentContainer expanded={expanded}>
                    <Styled.ListContainer square={true}>
                        <AutoSizer>
                            {({ width, height}) => {
                                return (<List
                                    height={height}
                                    width={width}
                                    rowHeight={80}
                                    rowCount={filteredTimers.length}
                                    rowRenderer={props => <ListRow {...props} timerStore={this.props.timerStore!}/>}
                                />);
                            }}
                        </AutoSizer>
                    </Styled.ListContainer>
                    <Styled.FormContainer>
                            <Route 
                                path={`${match.url}/:id`} 
                                component={selectedTimer && TemplateFormContainer}
                            />
                            {(mainWinLoading || applyingFilter) &&
                            <Loading>
                                <div style={{top: '-15%', position: 'relative'}}>
                                    <CircularProgress size={100}/>
                                </div>
                            </Loading>}
                    </Styled.FormContainer>
                </Styled.ContentContainer>
                
            </Styled.Container>
        );
    }
}
// tslint:disable-next-line:no-any
export default withStyles(styles as any)(withTranslation(['timers', 'common'])(Timers));